'use client';

import { FC } from 'react';
import emptyImage from '@wwe-portal/ui/assets/images/common/no-search-results.svg';

export const SearchResultEmpty: FC<{ searchKey: string; prefix?: string }> = ({
  searchKey,
  prefix = 'No results found for',
}) => {
  return (
    <div className="text-inlineTextColor12 flex flex-col items-center justify-center gap-4 px-5 py-10 text-xs">
      <img src={emptyImage} className="text-text700 h-[34px] w-[34px]" />
      <div>
        {prefix} <span className="text-quartz">&quot;{searchKey}&quot;</span>
      </div>
    </div>
  );
};
